import { toast } from 'react-toastify';
import { endOfMonth, startOfMonth } from 'date-fns';
import { Form } from '@ui';
import { withoutTzOffset } from '@lp/features/Scheduler/utils';
import { SchedulerSettingsSubmitRow } from '@lp/features/Scheduler/components';
import { useCCSchedulerServices } from '@lp/features/Scheduler/SchedulerClinicalCoordinators/hooks';
import { CCSchedulerSettingsRulesFormType } from '@lp/features/Scheduler/SchedulerClinicalCoordinatorsSettings/types';
import { CCSchedulerSettingsRulesForm } from '@lp/features/Scheduler/SchedulerClinicalCoordinatorsSettings/components';
import {
  ccSchedulerSettingRulesFormSchema,
  getDefaultCCSettingRulesValues,
} from '@lp/features/Scheduler/SchedulerClinicalCoordinatorsSettings/config';
import {
  useCCScheduleSettingsRulesQuery,
  useCCScheduleShiftsQuery,
  useCCSetScheduleSettingsRulesMutation,
} from '@/queries/resource/schedule';
import { retrieveUnifiedError } from '@/api/utils';

const currentMonthApiDateRange = {
  from: withoutTzOffset(startOfMonth(new Date())),
  to: withoutTzOffset(endOfMonth(new Date())),
};

export const CCSchedulerSettingsRulesTab = () => {
  const { data: shiftsData } = useCCScheduleShiftsQuery(currentMonthApiDateRange);
  const { data: rulesData } = useCCScheduleSettingsRulesQuery();
  const { mutateAsync, isPending } = useCCSetScheduleSettingsRulesMutation();
  const { userList } = useCCSchedulerServices(new Date(), shiftsData);

  const handleSubmit = async (data: CCSchedulerSettingsRulesFormType) => {
    try {
      await mutateAsync(data);
      toast.success(`Scheduler Settings updated successfully`);
    } catch (e) {
      const error = retrieveUnifiedError(e);
      toast.error(error.message);
    }
  };

  if (!userList || !rulesData) return null;

  return (
    <Form<CCSchedulerSettingsRulesFormType>
      defaultValues={getDefaultCCSettingRulesValues(rulesData, shiftsData)}
      schema={ccSchedulerSettingRulesFormSchema}
      onSubmit={handleSubmit}
    >
      <CCSchedulerSettingsRulesForm userList={userList} />
      <SchedulerSettingsSubmitRow backPath="/schedule/cc" isLoading={isPending} />
    </Form>
  );
};
